import { combineReducers } from "redux";
import { ScopeLoadingState } from "./scope-loading/types";
import { ScopeErrorState } from "./scope-error/types";
import { scopeLoadingReducer } from "./scope-loading/reducer";
import { scopeErrorReducer } from "./scope-error/reducer";
import { ClaimState } from "./mattress-claim/types";
import { claimReducer } from "./mattress-claim/reducer";

export interface RootState {
  scopeLoading: ScopeLoadingState;
  scopeError: ScopeErrorState;
  claim: ClaimState;
}

const createRootReducer = () =>
  combineReducers({
    scopeLoading: scopeLoadingReducer,
    scopeError: scopeErrorReducer,
    claim: claimReducer,
  });

export default createRootReducer;
